import React from "react";
import { FormattedMessage } from "react-intl";
import { StyledSelect } from "./form-style";
import { LegalInfoPolicyType } from "./domain/legalInfo.entity";
import { legalInfoMessages } from "./messages";

interface PolicySelectProps {
  value: LegalInfoPolicyType;
  onChange: (value: LegalInfoPolicyType) => void;
}

export const PolicySelect: React.FC<PolicySelectProps> = ({ value, onChange }) => {
  return (
    <div>
      <StyledSelect
        value={value}
        onChange={e => onChange(e.target.value as LegalInfoPolicyType)}
        required>
        <option value={LegalInfoPolicyType.PRIVACY_POLICY}>
          <FormattedMessage {...legalInfoMessages.privacyPolicy} />
        </option>
        <option value={LegalInfoPolicyType.COMMUNICATIONS_POLICY}>
          <FormattedMessage {...legalInfoMessages.communicationsPolicy} />
        </option>
      </StyledSelect>

      {value === LegalInfoPolicyType.PRIVACY_POLICY && (
        <div className="form-text mt-2">
          <FormattedMessage {...legalInfoMessages.policyTypeHelpPrivacy} />
        </div>
      )}
      {value === LegalInfoPolicyType.COMMUNICATIONS_POLICY && (
        <div className="form-text mt-2">
          <FormattedMessage {...legalInfoMessages.policyTypeHelpCommunication} />
        </div>
      )}
    </div>
  );
};
